import DefaultInfoCard from "../InfoCards/DefaultInfoCard";
import { formatTiles } from "../../functions";
import { ListTile } from "../Tiles/ListTile";

export const ListBanner = ({
	headerText,
	subtitle,
	content,
	ctas,
	isEven,
	variantStyling,
	formattedSectionStyles,
	listItems = [],
}) => {
	const formattedTiles = formatTiles(listItems);
	const imageComponent = <ListTile tiles={formattedTiles} isVertical={true} />;
	return (
		<DefaultInfoCard
			headerText={headerText}
			subtitle={subtitle}
			imageComponent={imageComponent}
			content={content}
			ctas={ctas}
			isEven={isEven}
			variantStyling={variantStyling}
			formattedSectionStyles={formattedSectionStyles}
		/>
	);
};
